// src/components/agents-calls-weekly-chart/agents-calls-weekly-chart.tsx

import React from 'react';
import BaseAgentCallsChart from '../base-agent-calls-chart/base-agent-calls-chart';
import { useAgentCallsData } from 'hooks/charts/agent-calls';
import { type CallSummaries } from 'src/types/call-summaries';

const AgentCallsWeeklyChart: React.FC<CallSummaries> = ({ summaries }) => {
  const chartData = useAgentCallsData(summaries, 'weekly');

  return (
    <BaseAgentCallsChart
      labels={chartData.labels}
      agentPeriodsCallSummaries={chartData.agentPeriodsCallSummaries}
      // TODO: check when implementing i18n
      chartTitle="Llamadas Semanales por Agente"
    />
  );
};

export default AgentCallsWeeklyChart;
